import React from 'react';
import { useFormContext } from 'react-hook-form';
import { PlusIcon, TrashIcon } from 'lucide-react';
const AssetsAndInsurance = () => {
  const {
    register
  } = useFormContext();
  return <div className="space-y-8" data-id="element-217">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-218">
        <p className="text-slate-700" data-id="element-219">
          Please provide information about your assets and insurance policies.
        </p>
      </div>
      {/* Real Estate */}
      <div className="space-y-4" data-id="element-220">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-221">
          Real Estate
        </h3>
        <div data-id="element-222">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-223">
            Do you own any real estate?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-224">
            <label className="inline-flex items-center" data-id="element-225">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('assets.realEstate.exists')} data-id="element-226" />
              <span className="ml-2" data-id="element-227">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-228">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('assets.realEstate.exists')} data-id="element-229" />
              <span className="ml-2" data-id="element-230">No</span>
            </label>
          </div>
        </div>
      </div>
      {/* Bank Accounts */}
      <div className="space-y-4" data-id="element-231">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-232">
          Bank Accounts
        </h3>
        <div data-id="element-233">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-234">
            Please list your bank accounts
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="e.g., Checking Account at ABC Bank, Savings Account at XYZ Bank" {...register('assets.bankAccounts')} data-id="element-235" />
        </div>
      </div>
      {/* Investments */}
      <div className="space-y-4" data-id="element-236">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-237">
          Investments
        </h3>
        <div data-id="element-238">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-239">
            Please list your investments
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="e.g., RRSPs, TFSAs, Stocks, Bonds" {...register('assets.investments')} data-id="element-240" />
        </div>
      </div>
      {/* Life Insurance */}
      <div className="space-y-4" data-id="element-241">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-242">
          Life Insurance
        </h3>
        <div data-id="element-243">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-244">
            Do you have life insurance?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-245">
            <label className="inline-flex items-center" data-id="element-246">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('insurance.life.exists')} data-id="element-247" />
              <span className="ml-2" data-id="element-248">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-249">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('insurance.life.exists')} data-id="element-250" />
              <span className="ml-2" data-id="element-251">No</span>
            </label>
          </div>
        </div>
      </div>
      {/* Other Assets */}
      <div className="space-y-4" data-id="element-252">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-253">
          Other Valuable Assets
        </h3>
        <div data-id="element-254">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-255">
            Please list any other valuable assets
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="e.g., Vehicles, Art, Jewelry, Collections" {...register('assets.other')} data-id="element-256" />
        </div>
      </div>
    </div>;
};
export default AssetsAndInsurance;